module.exports = __webpack_public_path__ + "img/interview.5d26d6fe.svg";